import { render, staticRenderFns } from "./cookingIntroduction.vue?vue&type=template&id=5325f997&"
import script from "./cookingIntroduction.vue?vue&type=script&lang=js&"
export * from "./cookingIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./cookingIntroduction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports